import React, { useRef } from 'react';
import IconClose from '../../assets/images/IconClose';
import logoBlack from '../../assets/images/logoBlack.svg';
import backgroundImg from '../../assets/images/bg-img.png';
import { clickOutside, downloadDivAsImage, numberToWords, overLayers } from '../../utils/common';
import { isEmpty } from 'lodash';
import bbpsLogo from '../../assets/images/BbpsLogo.png';
import bbpsLogo2 from '../../assets/images/Bbpslogo3.svg';
import { ModalWraper } from '../../Components/UI/styledConstants';
import { useEffect } from 'react';

const BbpsReceipt = ({ payDaital, onCloseModal, type="" }) => {
	const handleDownloadClick = (title) => {
		const divElement = document.getElementById('model');
		downloadDivAsImage(divElement, title);
	};


	const complainResp = payDaital?.txnStatusComplainResp;
 console.log("payDaital",payDaital)
	let status = "";

	// if(complainResp?.txnStatusComplainResp.toUpperCase() === "FAIL"){
	// 	status="red"
	// }else if(complainResp?.txnStatusComplainResp.toUpperCase() === "RESOLVED"){
	// 	status = "green";
	// }else{
	// 	status = "#adad08";
	// }

	const boxRef = useRef(null);
	useEffect(() =>{
		overLayers(true);
		clickOutside(true,boxRef,onCloseModal);
	
		return(() =>{
			overLayers(false)
			clickOutside(false,boxRef,onCloseModal);
		})
	
	},[]);

	return (
		<ModalWraper url={backgroundImg}>
			<div className="modal modal-success" id="model" ref={boxRef}>
				<div className="flex modal-header justify-between">
					<div className="logo self-center">
						<img src={logoBlack} alt={'logo'} />
						<div>
							<p>Invoicing and payments</p>
							<p>powered by Pay2Mobile</p>
						</div>
					</div>

					<div className="buttons">
						<img src={bbpsLogo2} alt="bbps logo" style={{ width: '9px' }} />
					</div>
				</div>
				<div className="modal-close" onClick={() => onCloseModal()}>
					<IconClose />
				</div>
				<div className="text-center modal-title flex items-center justify-center">
					{(type === "") && <h3 className="amount" style={{ lineHeight: '30px' }}>
						Your complaint is registered <br />
						successfully
					</h3>}
					
				</div>
				<div className="modal-body pd-10-20">
					<div className="txn-daital">
						<div className="flex justify-between txn-desc">
							<div className="txn-desc-left">Complaint Assigned: </div>
							<div className="txn-desc-left">{complainResp?.assigned}</div>
						</div>
						<div className="flex justify-between txn-desc">
							<div className="txn-desc-left">Complaint Id: </div>
							<div className="txn-desc-left">{complainResp?.complaintId}</div>
						</div>
						<div className="flex justify-between txn-desc">
							<div className="txn-desc-left">Reference Id: </div>
							<div className="txn-desc-left">{complainResp?.referenceId}</div>
						</div>

						{<div className="flex justify-between txn-desc">
							<div className="txn-desc-left">Complaint Status: </div>
							<div className="txn-desc-left">{complainResp?.complaintStatus}</div>
						</div>}
						
					</div>
				</div>
				<div className="buttons center gap-10" style={{ marginTop: '40px' }}>
					<button className="button-solid center gap-6" onClick={() => handleDownloadClick('BBPS Comptain')}>
						<i className="fa-solid fa-download"></i> Download
					</button>
					<button className="button-solid center gap-6" onClick={() => window.print()}>
						<i className="fa-solid fa-print"></i> Print
					</button>
				</div>
			</div>
		</ModalWraper>
	);
};

export default BbpsReceipt;
